import React from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Plan from './Plan';
import Partner from './Partner';
import { makeStyles } from '@material-ui/core/styles';
import {colors} from '../../../style/constants';

const useStyles = makeStyles((theme) => ({
  plans: {
    '& > div > div': {
      border: '5px #000 solid'
    },
    '& > :nth-child(1)': {
      '& ul > li::before': {
        background: colors.ATT_BLUE,
      },
      '& > div > div > :first-child': {
        background: colors.ATT_BLUE,
      },
      '& > svg': {
        transform: 'rotate(-29deg)',
        top: -48,
        left: -120,
        '&.active': {
          transform: 'rotate(-29deg) translate(-120px, 50px)',
        },
        [theme.breakpoints.down('lg')]: {
          top: -101,
          left: 5,
          transform: 'rotate(-15deg)',
          '&.active': {
            transform: 'rotate(-15deg) translate(-10px, -100px)',
          },
          [theme.breakpoints.down('md')]: {
            top: -80,
            left: 5,
            transform: 'rotate(-15deg)',
            '&.active': {
              transform: 'rotate(-15deg) translate(-10px, -90px)',
            },
            [theme.breakpoints.down('sm')]: {
              top: -65,
              '&.active': {
                transform: 'rotate(-15deg) translate(-10px, -65px)',
              },
              [theme.breakpoints.down('xs')]: {
                top: -65,
                left: -20,
                '&.active': {
                  transform: 'rotate(-15deg)',
                },
              },
            },
          },
        },
      },
      '& > div': {
        borderColor: colors.ATT_BLUE
      },
    },
    '& > :nth-child(2)': {
      '& ul > li::before': {
        background: colors.TURQUOISE,
      },
      '& > div > div > :first-child': {
        background: colors.TURQUOISE,
      },
      '& > svg': {
        height: 280,
        transform: 'rotate(-7deg)',
        top: -150,
        left: -57,
        '&.active': {
          transform: 'rotate(-7deg) translateY(-90px)',
        },
        [theme.breakpoints.down('lg')]: {
          top: -150,
          left: 'calc(100%/2 - 160px)',
          transform: 'rotate(0)',
          '&.active': {
            transform: 'translateY(-90px)',
          },
          [theme.breakpoints.down('md')]: {
            left: 'calc(100%/2 - 140px)',
            height: 240,
            top: -140,
            '&.active': {
              transform: 'translateY(-80px)',
            },
            [theme.breakpoints.down('sm')]: {
              left: 'calc(100%/2 - 110px)',
              height: 170,
              top: -100,
              '&.active': {
                transform: 'translateY(-50px)',
              },
              [theme.breakpoints.down('xs')]: {
                left: 'auto',
                right: -20,
                height: 115,
                top: -95,
                '&.active': {
                  transform: 'none',
                },
              },
            },
          },
        },
      },
      '& > div': {
        borderColor: colors.TURQUOISE
      },
    },
    '& > :nth-child(3)': {
      '& ul > li::before': {
        background: colors.LIGHT_BLUE,
      },
      '& > div > div > :first-child': {
        background: colors.LIGHT_BLUE,
      },
      '& > svg': {
        transform: 'scaleX(-1) rotate(-24deg)',
        top: -120,
        right: 67,
        '&.active': {
          transform: 'scaleX(-1) rotate(-24deg) translate(-70px, -120px)',
        },
        [theme.breakpoints.down('lg')]: {
          '&.active': {
            transform: 'scaleX(-1) rotate(-24deg) translate(-60px, -130px)',
          },
          [theme.breakpoints.down('md')]: {
            top: -100,
            right: 67,
            '&.active': {
              transform: 'scaleX(-1) rotate(-24deg) translate(-30px, -90px)',
            },
            [theme.breakpoints.down('sm')]: {
              top: -75,
              right: 47,
              '&.active': {
                transform: 'scaleX(-1) rotate(-24deg) translate(-20px, -70px)',
              },
              [theme.breakpoints.down('xs')]: {
                top: -50,
                right: 'auto',
                left: -20,
                '&.active': {
                  transform: 'scaleX(-1) rotate(-24deg)',
                },
              },
            },
          },
        },
      },
      '& > div': {
        borderColor: colors.LIGHT_BLUE
      },
    },
  }
}));

const Plans = (props) => {
  
  const renderPlans = () => {
    return props.plans.map((plan, index) => {
      return (
        <Plan lang={props.lang} plan={plan} index={index} key={index}/>
      );
    });
  };

  const classes = useStyles();
  return (
    <section>
      <Container>
        <Grid className={classes.plans} container justifyContent='space-between'>
          {renderPlans()}
        </Grid>
        <Partner lang={props.lang}/>
      </Container>
    </section>
  );
}

export default Plans;